import Print from './Print.vue';

export default Print;
